<template>
  <apexchart
    :ref="refChart"
    type="line"
    height="350"
    :options="options"
    :series="series"
  ></apexchart>
</template>

<script>
export default {
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    refChart: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: {
        chart: {
          type: "line",
          height: 350,
          width: '100%',
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [0, 4],
        },
        title: {
          text: "",
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
        },
        labels: [],
        yaxis: [
          {
            title: {
              text: "Personas",
            },
          },
          {
            opposite: true,
            title: {
              text: "Enfermedad laboral",
            },
          },
        ],
      },
    };
  },
  watch: {
    series() {
      const me = this;
      me.updateChart();
    },
    labels() {
      const me = this;
      me.updateChart();
    },
  },
  methods: {
    updateChart() {
      const me = this;
      const chart = me.$refs[me.refChart];
      me.$refs[me.refChart].updateOptions(
        {
          labels: [...me.labels],
        }
      );
      chart.updateSeries(me.series);
    },
  },
  created() {
    const me = this;
    me.options.title.text = me.title;
  },
  mounted() {
    const me = this;
    me.options.labels = [...me.labels];
  },
};
</script>

<style lang="scss" scoped></style>
